module.exports = __webpack_public_path__ + "static/media/icon-delete-white.facb71a5.svg";